import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MODAL_REF, ModalService } from '@ui/modal/modal.service';
import { ModalComponent } from '@ui/modal/modal.component';
import { InputComponent } from '@ui/input/input.component';
import { TendersService } from '@api/services/tenders.service';
import { CsvInvoiceArticle } from '@api/models/tender.model';
import { ConfirmService } from '@ui/confirm-modal/confirm.service';

@Component({
  selector: 'app-article-form-modal',
  standalone: true,
  imports: [ModalComponent, InputComponent, ReactiveFormsModule, CommonModule],
  template: `
    <ui-modal
      [title]="'Nieuw artikel toevoegen'"
      [submitText]="'Toevoegen'"
      [cancelText]="'Annuleren'"
      (close)="closeModal()"
      (save)="saveModal()"
      [disabled]="saving"
      [loading]="saving"
    >
      <form [formGroup]="form">
        <div class="flex flex-col gap-4">
          <ui-input
            id="product_name"
            label="Productnaam"
            placeholder="Moet gelijk zijn aan ZoHo Naam, Bijv. Cat 1: Rechte traplift"
            formControlName="product_name"
            [required]="true"
          />

          <ui-input
            id="product_code"
            label="Productcode"
            placeholder="Bijv. 13070"
            formControlName="product_code"
            [required]="true"
          />

          <ui-input
            id="unit_type"
            label="Eenheid type"
            placeholder="Bijv. Stuks(output) of Euro's"
            formControlName="unit_type"
            [required]="true"
          />
        </div>
      </form>
    </ui-modal>
  `,
  styles: `
    :host {
      display: block;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArticleFormModalComponent implements OnInit {
  private modalRef = inject(MODAL_REF);
  private modalService = inject(ModalService);
  private tendersService = inject(TendersService);
  private confirmService = inject(ConfirmService);

  tenderId: string = '';
  saving = false;

  form: FormGroup = new FormGroup({
    product_name: new FormControl('', Validators.required),
    product_code: new FormControl('', Validators.required),
    unit_type: new FormControl('', Validators.required),
  });

  ngOnInit() {
    // tenderId wordt doorgegeven via modal data en toegewezen via Object.assign
  }

  closeModal() {
    this.modalService.close(this.modalRef);
  }

  saveModal() {
    this.form.markAllAsTouched();

    if (this.form.invalid) {
      return;
    }

    const productName = this.form.value.product_name;

    // Vraag bevestiging of de naam klopt met ZoHo
    const confirm = this.confirmService.confirm({
      title: 'ZoHo naam verificatie',
      message: `Klopt de productnaam "${productName}" met de naam zoals deze in ZoHo staat?`,
      confirmText: 'Ja, klopt',
      cancelText: 'Nee, aanpassen',
    });

    confirm.then((confirmed) => {
      if (confirmed) {
        this.createArticle();
      }
      // Als niet bevestigd, blijft de modal open voor aanpassingen
    });
  }

  private createArticle() {
    this.saving = true;
    const articleData: Omit<CsvInvoiceArticle, 'id'> = {
      product_name: this.form.value.product_name,
      product_code: this.form.value.product_code,
      unit_type: this.form.value.unit_type,
      tender_id: this.tenderId,
    };

    this.tendersService.createCsvInvoiceArticle(articleData).subscribe({
      next: () => {
        this.saving = false;
        this.closeModal();
      },
      error: (error) => {
        console.error('Error creating article:', error);
        this.saving = false;
        // TODO: Show error notification
      }
    });
  }
}
